
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
);

/* ---------------------------------------------------
   Fixed colors for known vehicle groups
--------------------------------------------------- */
const VEHICLE_GROUP_COLORS = {
  SUV: "#22c55e",
  MUV: "#6366f1",
  Sedan: "#f59e0b",
  Hatchback: "#0ea5e9",
  Tempo: "#ec4899",
};

/* ---------------------------------------------------
   Auto-generate stable color for NEW vehicle groups
--------------------------------------------------- */
const generateColorFromText = (text) => {
  let hash = 0;

  for (let i = 0; i < text.length; i++) {
    hash = text.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 65%, 55%)`;
};

const VehicleUtilizationChart = ({ data = [] }) => {
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-gray-400">
        No data available
      </div>
    );
  }

  const labels = data.map((d) => d.vehicle_group);
  const values = data.map((d) => Number(d.total) || 0);

  // Dynamic colors: known groups + automatic colors for new groups
  const colors = labels.map(
    (group) =>
      VEHICLE_GROUP_COLORS[group] ||
      generateColorFromText(String(group ?? ""))
  );

  const chartData = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: colors,

        // Compact bars with reduced gaps
        categoryPercentage: 0.95,
        barPercentage: 0.95,
        maxBarThickness: 18,

        borderRadius: 4,
        borderSkipped: false,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,

    // Prevent chart animations from distracting during updates
    animation: {
      duration: 200,
    },

    plugins: {
      legend: {
        display: false,
      },

      tooltip: {
        callbacks: {
          label: (ctx) => `Duties: ${ctx.raw}`,
        },
      },
    },

    scales: {
      x: {
        beginAtZero: true,

        ticks: {
          precision: 0,
          stepSize: 1,
          font: {
            size: 10,
          },
        },

        grid: {
          color: "#eef2f7",
        },
      },

      y: {
        offset: true,

        ticks: {
          autoSkip: false,
          font: {
            size: 10,
          },
        },

        grid: {
          display: false,
        },
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default VehicleUtilizationChart;


